import { Box, Button } from "@mui/material";
import { UserForm } from "./UserForm";
import { LocationForm } from "./LocationForm";
import { TemperatureBox } from "./TemperatureBox";
import { PoolDimensionsForm } from "./PoolDimensionsForm";
import { useForm, FormProvider, FieldErrors } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  firstStepFormSchema,
  firstStepFormDefaultValues,
  FirstStepFormData,
} from "../../schemas/validationSchemas";
import { usePumpRecommendationContext } from "../../context/PumpRecommendationContext";
import { PoolDetailsForm } from "../PoolInfoSelectors";
import { usePoolCalculationSubmission } from "../../hooks/services";
import { useNavigate } from "react-router-dom";
import useResponsive from "../../hooks/useResponsive";
import { useScrollToError } from "../../hooks/useScrollToError";
import { ReactComponent as RightArrowIcon } from "../../assets/right-arrow.svg";

export const FirstStepContainer = () => {
  const {
    setFormData,
    setRecommendations,
    setIsCalculating,
    setError,
    setReportId,
  } = usePumpRecommendationContext();
  const navigator = useNavigate();
  const { isSm, isXs, isMd, isLg } = useResponsive();
  const { scrollToError } = useScrollToError();

  const isMobile = isSm || isXs;
  const isTablet = isMd || isLg;

  const poolCalculationSubmission = usePoolCalculationSubmission();

  const methods = useForm<FirstStepFormData>({
    defaultValues: firstStepFormDefaultValues,
    resolver: yupResolver(firstStepFormSchema),
    mode: "onSubmit",
  });

  const onSubmit = async (data: FirstStepFormData) => {
    setIsCalculating(true);
    setError(null);

    poolCalculationSubmission.mutate(data, {
      onSuccess: (result) => {
        console.log({ result });
        setReportId(result.reportId);
        setFormData(result.formData);
        setRecommendations(result.recommendations);
        setIsCalculating(false);
        navigator("/results");
      },
      onError: (error) => {
        setError(error.message);
        setIsCalculating(false);
      },
    });
  };

  const onError = (errors: FieldErrors<FirstStepFormData>) => {
    scrollToError(errors);
  };

  return (
    <FormProvider {...methods}>
      <Box component="form" onSubmit={methods.handleSubmit(onSubmit, onError)}>
        <UserForm />
        <PoolDetailsForm />
        <PoolDimensionsForm />
        <LocationForm />
        <TemperatureBox />
        <Box
          display={"flex"}
          alignItems={"center"}
          justifyContent={"flex-end"}
          flexDirection={"column"}
          pb={isMobile ? 2 : isTablet ? 2 : 4}
        >
          <Button
            startIcon={<RightArrowIcon />}
            variant="contained"
            type="submit"
            disabled={poolCalculationSubmission.isPending}
          >
            {poolCalculationSubmission.isPending
              ? "Calculating..."
              : "Get Davey Recommendation"}
          </Button>
        </Box>
      </Box>
    </FormProvider>
  );
};
